// extracted by mini-css-extract-plugin
export var contentBody = "_a5-9";
export var headerImage = "_a5-2";
export var imageButton = "_a5-7";
export var imageButtonIcon = "_a5-8";
export var imageHeader = "_a5-4";
export var imageHeaderText = "_a5-5";
export var imageOverlay = "_a5-3";
export var imageTitle = "_a5-6";
export var imageWrapper = "_a5-1";
export var taskList = "_a5-a";
export var widget = "_a5-0";